<div class="content mr-small" [innerHTML]="'review-footer' | labelSwapper: 'content' : true | async"></div>
<img lib-image image="logo.png" />
